import { Component, Inject }                  from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef }      from '@angular/material/dialog';

export interface ReportExportResultDialogData {
	title: string;
	message: string;
	filename: string;
	/** Hint telling the user where the file was saved (Downloads folder). */
	downloadsHint: string;
	/** Pre-translated button labels (resolved by the caller's TranslateService). */
	openLabel: string;
	closeLabel: string;
	/** Object URL of the downloaded blob, used by the "Open" button. */
	fileUrl: string;
}

/**
 * Result popup shown after a report export download completes.
 * Confirms the export and lets the user open the just-downloaded file.
 */
@Component({
	standalone:  false,
	selector:    'pmc-report-export-result-dialog',
	templateUrl: './report-export-result-dialog.component.html',
	styleUrls:   ['./report-export-result-dialog.component.scss']
})
export class ReportExportResultDialogComponent {

	constructor(public dialogRef: MatDialogRef<ReportExportResultDialogComponent>,
				@Inject(MAT_DIALOG_DATA) public data: ReportExportResultDialogData) {
	}

	openFile(): void {
		if (this.data.fileUrl)
			window.open(this.data.fileUrl, '_blank');
	}

	close(): void {
		this.dialogRef.close();
	}
}
